import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "downloadcircle",
  "use": "downloadcircle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"downloadcircle\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(1 1)\"><path fill=\"#6D3075\" d=\"M14.889 13.222v1.346a.32.32 0 0 1-.32.321H7.431a.32.32 0 0 1-.32-.32v-1.347a.556.556 0 1 0-1.112 0v1.667C6 15.499 6.5 16 7.111 16h7.778c.61 0 1.111-.5 1.111-1.111v-1.667a.556.556 0 0 0-1.111 0m-4.282.393l-1.964-1.964a.556.556 0 0 1 .786-.786l1.016 1.016V6.556a.555.555 0 1 1 1.11 0v5.325l1.017-1.016a.555.555 0 1 1 .786.786l-1.965 1.964a.555.555 0 0 1-.786 0\" /><circle cx=\"11\" cy=\"11\" r=\"11\" stroke=\"#6D3075\" stroke-linejoin=\"round\" stroke-width=\"1.3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/downloadcircle.svg
// module id = 16
// module chunks = 0